const shopHomepageTest = {
  displayField: 'title',
  name: 'z-shopHomepageTest',
  description: 'do not use - Shop Homepage (TEST, PLEASE USE "Shop Homepage")',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'shopHero',
      name: 'Shop Hero',
      type: 'Link',
      localized: true,
      required: false,
      validations: [ { linkContentType: [ 'searchHero' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'flexCollar',
      name: 'Flex Collar',
      type: 'Link',
      localized: true,
      required: false,
      validations: [ { linkContentType: [ 'flexCollar' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'shopNewestListings',
      name: 'Shop Newest Listings',
      type: 'Link',
      localized: true,
      required: false,
      validations: [ { linkContentType: [ 'shopNewestListings' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'bigPictureCta',
      name: 'Big Picture CTA',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'bigPictureCta' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'stackedTextAndImage',
      name: 'Stacked Text and Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'variantStackedTextImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'wideTextAndImage',
      name: 'Wide Text and Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'wideTextImage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'wideTextWithForm',
      name: 'Wide Text with Form',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'WideStackedTextImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    }
  ],
  sys: {
    id: 'shopHomepageTest',
    version: 4,
    updatedAt: '2023-08-03T14:33:09.242Z'
  }
};
export default shopHomepageTest;